const HOME_SCREEN = "/screenshots/home.png";
const REPORTS_SCREEN = "/screenshots/reports.png";

export const DEFAULT_COVER_FEATURES = [
  { key: "reports", label: "Smart Reports" },
  { key: "tracking", label: "Income & Expense Tracking" },
  { key: "secure", label: "Secure & Reliable" },
  { key: "decisions", label: "Better Decisions" },
];

export const formatBlogDate = (iso) =>
  new Date(`${iso}T00:00:00`).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

export const formatBlogTag = (tag) =>
  String(tag || "")
    .replace(/-/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());

export const getPostCover = (post) => post?.cover || post?.image || "/treasure-og-image.png";

export const getPostCategory = (post) => post?.category || formatBlogTag(post?.tags?.[0]) || "Guide";

/** Finished 16:9 banners live in /covers/. Screenshots stay composed in the marketing template. */
export const isBannerCover = (src = "") => /\/covers\//i.test(src);

export const screenshotWebp = (src) =>
  typeof src === "string" && /\/screenshots\/.+\.png$/i.test(src) ? src.replace(/\.png$/i, ".webp") : null;

export const getCoverHeadline = (post) => {
  if (post?.headline) {
    return { lead: post.headline, accent: post.headlineAccent || "" };
  }
  const title = String(post?.title || "").trim();
  const words = title.split(/\s+/).filter(Boolean);
  const accentCount = words.length >= 6 ? 3 : words.length >= 4 ? 2 : 0;
  if (!accentCount) return { lead: title, accent: "" };
  return {
    lead: words.slice(0, -accentCount).join(" "),
    accent: words.slice(-accentCount).join(" "),
  };
};

export const getCoverScreens = (post) => {
  const primary = getPostCover(post) || HOME_SCREEN;
  if (post?.coverSecondary) {
    return { primary, secondary: post.coverSecondary };
  }
  const secondary = /reports/i.test(primary) ? HOME_SCREEN : REPORTS_SCREEN;
  return { primary, secondary };
};

export const getCoverFeatures = (post) => {
  const items = Array.isArray(post?.features) && post.features.length ? post.features : DEFAULT_COVER_FEATURES;
  return items.slice(0, 4).map((item) =>
    typeof item === "string" ? { key: item, label: item } : { key: item.key || item.label, label: item.label },
  );
};

export const getOgImage = (post) =>
  post?.ogImage || "/covers/treasure-16-9.jpg";

export const getPostUpdated = (post) => post?.updated || post?.date;

export const getReadingLabel = (post) => {
  const minutes = post?.readingTime || Math.max(1, Math.round((post?.wordCount || 800) / 200));
  return `${minutes} min read`;
};
